// extracted by mini-css-extract-plugin
module.exports = {"ratingLink":"Rating_ratingLink__DkH53","sm":"Rating_sm__W2PjG","ratingAndReviews":"Rating_ratingAndReviews__bPIL8"};